import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-table-6/react-table.css";
import Loader from 'react-loader-spinner';
import "./EmailerSettings.css"

export default class EmailerSettings extends Component {
    constructor() {
        super();
        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteEmailerSettingApi()
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

        this.state = {
            displayConfigSetting: false,
            hideDeletePopup: false,
            loadView: false,
            fields: {},
            isInEditState: true
        }
    }


    componentDidMount() {
        let thisController = this;
        setTimeout(() => {
            thisController.fetchEmailerSettingApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.state.fields["fullName"] = "";
            thisController.setState(thisController.state)
            thisController.fetchEmailerSettingApi(event.projectId);
        });
    }

    displayConfigEmailerSetting = () => {
        this.state.displayConfigSetting = true;
        this.setState(this.state);
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    notifyEnterValues = () => {
        toast.dismiss();
        toast(<b> <img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; Please fill mandatory fields</b >, {
            position: "top-center"
        });
    }

    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    validateFields = () => {
        var fields = this.state.fields;
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        const numberRegex = /^[0-9\b]+$/;

        if (!fields["fullName"] || fields["fullName"].trim() == "") {
            this.notifyEnterValues();
            return false;
        } else if (!fields["emailAddress"] || fields["emailAddress"].trim() == "") {
            this.notifyEnterValues();
            return false;
        } else if (!pattern.test(fields["emailAddress"])) {
            this.notifyInvalidFields("Please enter valid email address");
            return false;
        } else if (!fields["password"] || fields["password"].trim() == "") {
            this.notifyEnterValues();
            return false;
        } else if (!fields["outgoingServer"] || fields["outgoingServer"].trim() == "") {
            this.notifyEnterValues();
            return false;
        } else if ((fields["requiresSSL"] !== "true" && fields["requiresSSL"] !== "false") &&
            (fields["requiresSSL"] !== true && fields["requiresSSL"] !== false)) {
            this.notifyInvalidFields("Please enter valid Requires SSL value");
            return false;
        } else if ((fields["requiresAuthentication"] !== "true" && fields["requiresAuthentication"] !== "false") &&
            (fields["requiresAuthentication"] !== true && fields["requiresAuthentication"] !== false)) {
            this.notifyInvalidFields("Please enter valid Requires Authentication value");
            return false;
        } else if (!fields["outgoingPortSSL"] || fields["outgoingPortSSL"] == "") {
            this.notifyEnterValues();
            return false;
        } else if (!numberRegex.test(fields["outgoingPortSSL"])) {
            this.notifyInvalidFields("Please enter valid Outgoing Port for SSL value");
            return false;
        } if (fields["requiresTLS"] !== "true" && fields["requiresTLS"] !== "false" &&
            fields["requiresTLS"] !== true && fields["requiresTLS"] !== false) {
            this.notifyInvalidFields("Please enter valid Requires TLS value");
            return false;
        } else if (!fields["signature"] || fields["signature"].trim() == "") {
            this.notifyEnterValues();
            return false;
        } else {
            return true;
        }
    }

    fetchEmailerSettingApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let emailerSettingComponent = this;
        emailerSettingComponent.state.loadView = false;
        $.ajax({
            url: "/api/emailer-settings/" + projectId,
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                emailerSettingComponent.state.loadView = true;
                if (res.success === true) {
                    if (Object.keys(res.result).length != 0) {
                        emailerSettingComponent.state.displayConfigSetting = true;
                        emailerSettingComponent.state.isInEditState = false;
                        emailerSettingComponent.state.fields = res.result;
                        emailerSettingComponent.setState(emailerSettingComponent.state);
                    } else {
                        document.getElementById("outgoingServer").value = "";
                        document.getElementById("requiresSSL").value = "";
                        document.getElementById("requiresAuthentication").value = "";
                        document.getElementById("outgoingPortSSL").value = "";
                        document.getElementById("outgoingPortTLS").value = "";
                        document.getElementById("requiresTLS").value = "";
                        document.getElementById("emailAddress").value = "";
                        document.getElementById("password").value = "";
                        document.getElementById("fullName").value = "";
                        document.getElementById("incomingServer").value = "";
                        document.getElementById("incomingPort").value = "";
                        document.getElementById("signature").value = "";
                        emailerSettingComponent.state.fields = {};
                        emailerSettingComponent.state.displayConfigSetting = false;
                        emailerSettingComponent.state.isInEditState = true;
                        emailerSettingComponent.setState(emailerSettingComponent.state);
                    }
                } else {
                    if (document.getElementById("outgoingServer") != null) {
                        document.getElementById("outgoingServer").value = "";
                        document.getElementById("requiresSSL").value = "";
                        document.getElementById("requiresAuthentication").value = "";
                        document.getElementById("outgoingPortSSL").value = "";
                        document.getElementById("outgoingPortTLS").value = "";
                        document.getElementById("requiresTLS").value = "";
                        document.getElementById("emailAddress").value = "";
                        document.getElementById("password").value = "";
                        document.getElementById("fullName").value = "";
                        document.getElementById("incomingServer").value = "";
                        document.getElementById("incomingPort").value = "";
                        document.getElementById("signature").value = "";
                        emailerSettingComponent.state.fields = {};
                        emailerSettingComponent.state.displayConfigSetting = false;
                        emailerSettingComponent.state.isInEditState = true;
                        emailerSettingComponent.setState(emailerSettingComponent.state);
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    validateOptionalFields = () => {
        var fields = this.state.fields;
        const numberRegex = /^[0-9\b]+$/;
        if (fields["outgoingPortTLS"] != undefined &&
            fields["outgoingPortTLS"] != "" && !numberRegex.test(fields["outgoingPortTLS"])) {
            this.notifyInvalidFields("Please enter valid Outgoing Port for TLS value");
            return false;
        } else if (fields["incomingPort"] != undefined &&
            fields["incomingPort"] != "" && !numberRegex.test(fields["incomingPort"])) {
            this.notifyInvalidFields("Please enter valid Incoming Port value");
            return false;
        } else {
            return true;
        }
    }

    saveEmailerSetting = () => {
        if (this.validateFields() && this.validateOptionalFields()) {
            let emailerSettingComponent = this;
            emailerSettingComponent.state.fields["projectId"] = localStorage.getItem("currentProjectId");
            var data = emailerSettingComponent.state.fields;
            $.ajax({
                url: "/api/emailer-data",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        emailerSettingComponent.notifySuccessToast("Emailer Setting Updated Successfully");
                        emailerSettingComponent.fetchEmailerSettingApi();
                        emailerSettingComponent.setState(emailerSettingComponent.state);
                    } else {
                        emailerSettingComponent.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    deleteEmailerSettingApi = () => {
        let emailerSettingComponent = this;
        $.ajax({
            url: "/api/emailer-delete/" + emailerSettingComponent.state.fields.id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    emailerSettingComponent.setState({ hideDeletePopup: false });
                    emailerSettingComponent.notifySuccessToast("Deleted Successfully");
                    emailerSettingComponent.fetchEmailerSettingApi();
                } else {
                    emailerSettingComponent.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeFieldsEditable = () => {
        this.state.isInEditState = true;
        this.setState(this.state);
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.loadView}
                    height={300}
                    width={50}
                    timeout={3000}
                    style={{ textAlign: 'center' }} />
                <ToastContainer className="Toast-at-center" />

                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <div className="wrapper" style={{ display: this.state.loadView ? 'block' : 'none' }}>
                    <div className="row">
                        <div className="col-12">
                            {/* Custom Tabs */}
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '20px'
                            }}>Configure Email Settings</h6>

                            <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>
                                <div className="tab-content col-12 p-0">
                                    <div className="tab-pane active show" id="tab_1">
                                        <div className="card card-primary mt-3">
                                            <div className="card-body raise-form">
                                                <div className="col-sm-12">
                                                    <div className="col-sm-5"
                                                        style={{
                                                            display: this.state.displayConfigSetting ? 'none' : 'block'
                                                        }}>
                                                        <button className="btn action-button"
                                                            style={{
                                                                marginTop: "10px",
                                                            }} onClick={this.displayConfigEmailerSetting}>Configure Emailer Settings</button>
                                                    </div>
                                                    <div style={{
                                                        display: this.state.displayConfigSetting ? 'block' : 'none'
                                                    }}>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Full Name :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} id="fullName"
                                                                    value={this.state.fields.fullName} name="fullName" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Email Address :</div>
                                                            <div className="col-sm-5">
                                                                <input type="email" className="form-control" onChange={this.handleChange} id="emailAddress"
                                                                    value={this.state.fields.emailAddress} name="emailAddress" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Password :</div>
                                                            <div className="col-sm-5">
                                                                <input type="password" className="form-control" onChange={this.handleChange} id="password"
                                                                    value={this.state.fields.password} name="password" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Outgoing Server :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} id="outgoingServer"
                                                                    value={this.state.fields.outgoingServer} name="outgoingServer" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Requires SSL :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} id="requiresSSL"
                                                                    value={this.state.fields.requiresSSL} name="requiresSSL" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Requires Authentication :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} disabled={!this.state.isInEditState}
                                                                    value={this.state.fields.requiresAuthentication} name="requiresAuthentication" id="requiresAuthentication"
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Outgoing Port for SSL :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} id="outgoingPortSSL"
                                                                    value={this.state.fields.outgoingPortSSL} name="outgoingPortSSL" disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Outgoing Port for TLS :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control placeholder-align" name="outgoingPortTLS" onChange={this.handleChange} id="outgoingPortTLS"
                                                                    value={this.state.fields.outgoingPortTLS} placeholder={!this.state.isInEditState ? "" : "Optional"} disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Requires TLS :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange}
                                                                    value={this.state.fields.requiresTLS} name="requiresTLS" disabled={!this.state.isInEditState} id="requiresTLS"
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px', }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Incoming Server :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} name="incomingServer" id="incomingServer"
                                                                    value={this.state.fields.incomingServer} placeholder={!this.state.isInEditState ? "" : "Optional"} disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Incoming Port :</div>
                                                            <div className="col-sm-5">
                                                                <input type="text" className="form-control" onChange={this.handleChange} name="incomingPort" id="incomingPort"
                                                                    value={this.state.fields.incomingPort} placeholder={!this.state.isInEditState ? "" : "Optional"} disabled={!this.state.isInEditState}
                                                                    style={{ border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2', borderRadius: '5px', padding: '5px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row" style={{ marginTop: '5px' }}>
                                                            <div className="col-sm-3" align="right" style={{ marginTop: '7px' }}>Signature :</div>
                                                            <div className="col-sm-5">
                                                                <textarea type="text" className="form-control" onChange={this.handleChange} id="signature"
                                                                    value={this.state.fields.signature} name="signature" disabled={!this.state.isInEditState}
                                                                    style={{
                                                                        border: !this.state.isInEditState ? "1px solid #ffffff" : '1px solid #b2b2b2',
                                                                        borderRadius: '5px', padding: '5px', background: '#ffffff'
                                                                    }} />
                                                            </div>
                                                        </div>


                                                        <div className="form-group col-sm-12" Align="center">
                                                            <button type="button" className="btn btn-primary navyblue-btn"
                                                                style={{ marginLeft: '-90px' }} onClick={!this.state.isInEditState ? this.makeFieldsEditable : this.saveEmailerSetting}
                                                            >{!this.state.isInEditState ? "Edit" : "Save"}</button>
                                                            <button type="button" className="btn btn-primary navyblue-btn"
                                                                onClick={() => {
                                                                    (this.state.fields.id == null || this.state.fields.id == undefined) ? this.fetchEmailerSettingApi() :
                                                                    this.setState({
                                                                        hideDeletePopup: true,
                                                                    })
                                                                }}
                                                            >Delete</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <DialogComponent width='400px' style={{ marginTop: "150px", position: "fixed" }} animationSettings={this.settings}
                                header='Emailer Settings' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                            </DialogComponent>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/EmailerSetting.js